import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-900 font-medium text-xl mb-3 mt-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "m-0 mb-2 p-0 text-600 line-height-3" }, "Welcome to your Smsify dashboard!", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "m-0 mb-6 p-0 text-600 line-height-3" }, "Get started making a campaign, purchase a phone number, or manage your existing campaigns.", -1)
const _hoisted_4 = { class: "grid" }
const _hoisted_5 = { class: "col-12 lg:col-6 xl:col-3" }
const _hoisted_6 = { class: "surface-card shadow-2 p-3 border-1 border-50 border-round" }
const _hoisted_7 = { class: "flex justify-content-between mb-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "block text-500 font-medium mb-3" }, "Campaigns", -1)
const _hoisted_9 = { class: "text-900 font-medium text-xl" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  class: "flex align-items-center justify-content-center bg-blue-100 border-round",
  style: {"width":"2.5rem","height":"2.5rem"}
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-megaphone text-blue-500 text-xl" })
], -1)
const _hoisted_11 = { class: "col-12 lg:col-6 xl:col-3" }
const _hoisted_12 = { class: "surface-card shadow-2 p-3 border-1 border-50 border-round" }
const _hoisted_13 = { class: "flex justify-content-between mb-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "block text-500 font-medium mb-3" }, "Phone Numbers", -1)
const _hoisted_15 = { class: "text-900 font-medium text-xl" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", {
  class: "flex align-items-center justify-content-center bg-blue-100 border-round",
  style: {"width":"2.5rem","height":"2.5rem"}
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-phone text-blue-500 text-xl" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ScrollPanel = _resolveComponent("ScrollPanel")!

  return (_openBlock(), _createBlock(_component_ScrollPanel, { style: {"width":"100%","height":"78vh"} }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(`Welcome, ${_ctx.userName}`), 1),
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", null, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.campaignCount ?? '—'), 1)
              ]),
              _hoisted_10
            ]),
            _createVNode(_component_router_link, {
              class: "text-sm text-cyan-600",
              to: { name: _ctx.routeNames.campaigns}
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Go to Campaigns >> ")
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", null, [
                _hoisted_14,
                _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.phoneNumberCount ?? '—'), 1)
              ]),
              _hoisted_16
            ]),
            _createVNode(_component_router_link, {
              class: "text-sm text-cyan-600",
              to: { name: _ctx.routeNames.phoneNumberDetails }
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Go to Phone Numbers >> ")
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}